import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTimetableDetails, IUpdateTimetableDetailsRequestBody } from 'src/api/updateTimetableDetails';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from 'src/hooks/QueryKeys';

// PATCH /timetables/:id is used from more than one place (the details tray opens from both the
// Timetable page and the Timetables list) - this wraps the call plus the cache invalidation every
// caller needs afterwards, so it isn't reimplemented at each call site. UI-specific effects
// (tracking, notifications, closing the tray) stay with the caller, same split as useUpdateTimetable.
export const useUpdateTimetableDetails = (timetableId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (details: IUpdateTimetableDetailsRequestBody) => updateTimetableDetails(timetableId, details),
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [QueryKeys.timetable, getBrandId(), timetableId] });
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.timetables] });
    },
  });
};
